// extracted by mini-css-extract-plugin
export var footer = "_qq-0";
export var inherit = "_qq-1";
export var input = "_qq-2";
export var modalContent = "_qq-3";
export var quillEditor = "_qq-4";
export var subtitle = "_qq-5";